import { GameLeaderboardTableRowProps } from './props';
import Multiplier from './Multiplier';
import { WalletService } from '@starsoft/common/services';
import { Coin } from '@/models/coin';
import useTranslation from 'next-translate/useTranslation';
import { Bet } from '@/models/bet';
import GameLeaderboardTableRowSkeleton from './Skeleton';
import { memo } from 'react';
import styles from '../../styles.module.scss';
import { BetStatus } from '@/models/bet/status';
import ValueWithCoinCell from '@/components/core/Table/CustomCells/ValueWithCoinCell';
import TableGameBetCell from '@/components/core/Table/CustomCells/TableGameBetCell';
import TableUser from '@/components/core/Table/CustomCells/TableUser';
import { getMoneyOrAmount } from '@starsoft/common/utils';
import { BetStatusId } from '@/models/bet/status/id';

function GameLeaderboardTableRow({
  bet,
  isLoading,
  shouldShowResult,
  shouldShowReducedInfo,
}: GameLeaderboardTableRowProps) {
  const { t } = useTranslation('smash-racing');
  const showProfit =
    bet?.status?.id?.toString() !== BetStatusId.Open?.toString() &&
    shouldShowResult;

  if (isLoading) {
    return (
      <GameLeaderboardTableRowSkeleton
        shouldShowReducedInfo={shouldShowReducedInfo}
      />
    );
  }

  return (
    <tr className={styles.table__row}>
      <td
        className={`${styles.table__row__data} ${styles['table__row__data--primary']}`}
      >
        <TableUser player={bet?.player} />
      </td>

      {!shouldShowReducedInfo ? (
        <>
          <td
            className={`${styles.table__row__data} ${styles['table__row__data--center']}`}
          >
            <Multiplier bet={bet} shouldShowResult={shouldShowResult} />
          </td>

          <td
            className={`${styles.table__row__data} ${styles['table__row__data--center']}`}
          >
            <ValueWithCoinCell
              coin={bet?.coin as Coin}
              value={WalletService.maskCurrency({
                amount: getMoneyOrAmount(bet?.amount),
                coin: bet?.coin,
                hideSymbol: true,
              })}
            />
          </td>

          <td
            className={`${styles.table__row__data} ${styles['table__row__data--right']}`}
          >
            {bet?.status?.id?.toString() !== BetStatusId.Open?.toString() &&
            shouldShowResult ? (
              <TableGameBetCell bet={bet} isProfitStyle isFlexEnd />
            ) : (
              t('betting_label')
            )}{' '}
          </td>
        </>
      ) : (
        <td
          className={`${styles.table__row__data} ${styles['table__row__data--right']}`}
        >
          <TableGameBetCell
            bet={bet as Bet}
            isProfitStyle={showProfit}
            showAmount={!showProfit}
            isFlexEnd
          />
        </td>
      )}
    </tr>
  );
}

export default memo(GameLeaderboardTableRow);
